import { render, staticRenderFns } from "./AddressInformation.vue?vue&type=template&id=c1ca2fa2&scoped=true&"
import script from "./AddressInformation.vue?vue&type=script&lang=ts&"
export * from "./AddressInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ca2fa2",
  null
  
)

export default component.exports